import { Box } from '@mui/material'
import * as React from 'react'

interface TabPanelProps {
  children?: React.ReactNode
  currentTab: string
  value: string
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, currentTab, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== currentTab}
      id={`simple-tabpanel-${value}`}
      aria-labelledby={`simple-tab-${value}`}
      {...other}
    >
      {value === currentTab && <Box width="100%">{children}</Box>}
    </div>
  )
}
